export var VectorTileGeomType;
(function (VectorTileGeomType) {
    VectorTileGeomType[VectorTileGeomType["UNKNOWN"] = 0] = "UNKNOWN";
    VectorTileGeomType[VectorTileGeomType["POINT"] = 1] = "POINT";
    VectorTileGeomType[VectorTileGeomType["LINESTRING"] = 2] = "LINESTRING";
    VectorTileGeomType[VectorTileGeomType["POLYGON"] = 3] = "POLYGON";
})(VectorTileGeomType || (VectorTileGeomType = {}));
//# sourceMappingURL=tiles.vector.interfaces.js.map